import { render } from "./PSwitcher.vue?vue&type=template&id=1f4c821a&ts=true"
import script from "./PSwitcher.vue?vue&type=script&lang=ts"
export * from "./PSwitcher.vue?vue&type=script&lang=ts"

import "./PSwitcher.vue?vue&type=style&index=0&id=1f4c821a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__